import { IconDesktop } from '@arco-design/web-react/icon';

/** 与调度资源池菜单「裸金属节点组」同一图标（列表 Avatar 传 React 组件，与菜单 SVG 一致） */
export const BARE_METAL_POOL_ICON = IconDesktop;

/** 节点组列表路径 */
export const BARE_METAL_NODE_GROUP_LIST_PATH = '/bare-metal/node-groups';

export const bareMetalNodeGroupDetailPath = (name: string) => `${BARE_METAL_NODE_GROUP_LIST_PATH}/detail/${name}`;
export const bareMetalNodeGroupCreatePath = `${BARE_METAL_NODE_GROUP_LIST_PATH}/create`;
export const bareMetalNodeGroupEditPath = (name: string) => `${BARE_METAL_NODE_GROUP_LIST_PATH}/edit/${name}`;
/** 节点组成员 → 裸金属节点详情（嵌套路由，面包屑多一级） */
export const bareMetalNodeGroupMemberDetailPath = (groupName: string, nodeName: string) =>
  `${bareMetalNodeGroupDetailPath(groupName)}/node/${nodeName}`;

/** DNS-1123 名称（最长 63） */
export const NODE_GROUP_NAME_REGEX = /^[a-z0-9]([-a-z0-9]*[a-z0-9])?$/;

export const NODE_GROUP_API_VERSION = 'computing.infra.stack.io/v1';
export const NODE_GROUP_KIND = 'BmsNodeGroup';

export const DEFAULT_CPU_UNIT = 'Core';
export const DEFAULT_MEMORY_UNIT = 'Gi';
export const DEFAULT_GPU_UNIT = 'Card';
export const DEFAULT_DISK_UNIT = 'GB';
export const DEFAULT_NIC_UNIT = 'Port';
